__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/a81fe94/packs/";